import Menu from "./Menu";
import styled from "styled-components";
import TopLogo from "./TopLogo";
import WhatsApp from "./WhatsApp";
import BottomBar from "./Bottom";
import LanguageSelector from "./LanguageSelector";

export default function Main() {
  return (
    <>
      <TopLogo />
      <Message>PÁGINA EM MANUTENÇÃO</Message>
      <BottomBar />
    </>
  );
}
const Message = styled.h1`
  color: #ffffff;
  display: flex;
  justify-content: center;
  font-size: 50px;
`;
